import {ErrorHandler, Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from "@angular/common/http";
import {Order} from "../../shared/models/Order";
import {catchError, Observable, tap, throwError} from "rxjs";
import {OrderPosition} from "../../shared/models/OrderPosition";
import { v4 as uuidv4 } from "uuid";
import {TableNumberService} from "./table-number.service";
import {environment} from "../../../environments/environment";
import {CategoryDto} from "../../shared/models/category-dto";
import {MatSnackBar} from "@angular/material/snack-bar";

@Injectable({
  providedIn: 'root'
})
export class OrderService {

  private baseUrlOrderService = environment.apiUrl + 'order'
  private order?: Order;

  constructor(private http: HttpClient, private errorHandler: ErrorHandler, private _snackBar: MatSnackBar) { }

  getOrder(): Order {
    return this.order!;
  }

  setOrder(order: Order) {
    this.order = order;
  }

  clearOrder() {
    this.order = undefined;
  }

  sendTableOrder(order: Order): Observable<any> {
    return this.http.post<any>(`${this.baseUrlOrderService}/tableOrderQueue`, order).pipe(
      tap(_ => this.log('post send table order')),
      catchError(this.handleError<Order[]>('send table order', []))
    );
  }

  sendReceipt(order: Order): Observable<any> {
    return this.http.post<any>(`${this.baseUrlOrderService}/receiptQueue`, order).pipe(
      tap(_ => this.log('post send receipt')),
      catchError(this.handleError<Order[]>('send receipt', []))
    );
  }

  getAllOrders(): Observable<any> {
    return this.http.get<any>(`${this.baseUrlOrderService}/allOrders`).pipe(
      tap(_ => this.log('get all orders')),
      catchError(this.handleError<Order[]>('get all orders', []))
    );
  }

  getAllOrdersOfShift(shiftId: string): Observable<any> {
    return this.http.get<any>(`${this.baseUrlOrderService}/allOrders/${shiftId}`).pipe(
      tap(_ => this.log('get all orders for shift')),
      catchError(this.handleError<Order[]>('getAllOrdersOfShift', []))
    );
  }

  getAllReceipts(): Observable<any> {
    return this.http.get<any>(`${this.baseUrlOrderService}/allReceipts`).pipe(
      tap(_ => this.log('get all receipts')),
      catchError(this.handleError<Order[]>('get all receipts', []))
    );
  }

  getAllReceiptsOfShift(shiftId: string): Observable<any> {
    return this.http.get<any>(`${this.baseUrlOrderService}/allReceipts/${shiftId}`).pipe(
      tap(_ => this.log('get all receipts')),
      catchError(this.handleError<Order[]>('get all receipts', []))
    );
  }

  getAllCancelledMarkedReceiptPositions(): Observable<any> {
    return this.http.get<any>(`${this.baseUrlOrderService}/cancelledreceipts/all`).pipe(
      tap(_ => this.log('get all cancelled unconfirmed receipt positions')),
      catchError(this.handleError<Order[]>('get all cancelled unconfirmed receipt positions', []))
    );
  }

  markOrderPositionAsCancelled(guid: string): Observable<any> {
    return this.http.delete<any>(`${this.baseUrlOrderService}/markSinglePositionForCancellation/${guid}`).pipe(
      tap(_ => this.log('mark for cancellation')),
      catchError(this.handleError<Order[]>('mark for cancellation', []))
    );
  }

  cancelOrderPosition(guid: string, user: string): Observable<any> {
    return this.http.delete<any>(`${this.baseUrlOrderService}/cancelSinglePosition/${guid}/${user}`).pipe(
      tap(_ => this.log('cancel order position')),
      catchError(this.handleError<Order[]>('cancel order position', []))
    );
  }

  declineCancelOrderPosition(guid: string, user: string): Observable<any> {
    return this.http.delete<any>(`${this.baseUrlOrderService}/declineCancelSinglePosition/${guid}/${user}`).pipe(
      tap(_ => this.log('decline cancel order position')),
      catchError(this.handleError<Order[]>('decline cancel order position', []))
    );
  }

  deleteAllTenantOrders(tenantId: string): Observable<any> {
    return this.http.delete<any>(`${this.baseUrlOrderService}/deleteAllTenantOrders/${tenantId}`).pipe(
      tap(_ => this.log('delete all tenant orders')),
      catchError(this.handleError<Order[]>('delete all tenant orders', []))
    );
  }

  /**
   * Handle Http operation that failed.
   * Let the app continue.
   * @param operation - name of the operation that failed
   * @param result - optional value to return as the observable result
   */
  private handleError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {

      // TODO: send the error to remote logging infrastructure
      console.error(error); // log to console instead

      this.errorHandler.handleError(error);

      // TODO: better job of transforming error for user consumption
      this.log(`${operation} failed: ${error.message}`);

      this._snackBar.open('Es ist ein Fehler aufgetreten.', 'Schließen', {duration: 3000});

      // Let the app keep running by returning an empty result.
      return throwError(() => error); //of(result as T);
    };
  }

  /** Log a HeroService message with the MessageService */
  private log(message: string) {
    console.log(`OrderService: ${message}`);
  }



}
